import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from './confirm-modal.component';

export type ConfirmOptions = {
  title: string;
  body: string;
  positive?: string;
  negative?: string;
};

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private readonly modalService = inject(NgbModal);

  async ask(options: ConfirmOptions): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'confirm-modal-title',
      centered: true,
    });
    const instance = modalRef.componentInstance as ConfirmModalComponent;
    instance.title = options.title;
    instance.body = options.body;
    if (options.positive !== undefined) {
      instance.positive = options.positive;
    }
    if (options.negative !== undefined) {
      instance.negative = options.negative;
    }
    try {
      const result = await modalRef.result;
      return result === 'Ja';
    } catch {
      return false;
    }
  }
}
